import MwsColors = require('./colors');

import { colors } from "material-ui/styles";

import { fade } from "material-ui/utils/colorManipulator";
import Spacing from "material-ui/styles/spacing";

export default {
    spacing: Spacing,
    fontFamily: '"Open Sans", sans-serif',
    palette: {
        primary1Color: colors.blue500,
        primary2Color: MwsColors.mwsGrey600,
        primary3Color: MwsColors.mwsGrey400,
        accent1Color: colors.blue500,
        accent2Color: colors.blue200,
        accent3Color: colors.blue100,
        textColor: MwsColors.mwsGrey900,
        alternateTextColor: MwsColors.mwsGrey50,
        canvasColor: colors.white,
        borderColor: MwsColors.mwsGrey300,
        disabledColor: fade(MwsColors.mwsGrey900, 0.3),
        iconPositiveColor: '#4896f3',
        iconNegativeColor: '#db2412'
    }
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/material-ui/diyLightRawTheme.ts
 **/